import clsx from 'clsx';
import {
  type ElementType,forwardRef, type HTMLAttributes, type ReactNode
} from 'react';

import styles from './typography.module.scss';

export interface TextProps extends Omit<HTMLAttributes<HTMLElement>, 'as'> {
  /**
   * The HTML element to render
   * Default: p
   */
  as?: 'p' | 'span' | 'div' | 'label';
  /**
   * Font size variant
   * Default: md (14px)
   */
  size?: 'md' | 'sm';
  /**
   * Font weight variant
   * Default: normal (400)
   */
  weight?: 'light' | 'normal' | 'medium' | 'bold';
  /**
   * Associates the label with a form control (when as="label")
   */
  htmlFor?: string;
  children?: ReactNode;
}

export const Text = forwardRef<HTMLElement, TextProps>(
  (
    {
      as = 'p',
      size = 'md',
      weight = 'normal',
      children,
      className,
      ...props
    },
    ref
  ) => {
    const Tag = as as ElementType;

    const textClasses = clsx(
      styles.text,
      styles[`text--${ size }`],
      styles[`text--${ weight }`],
      className
    );

    return (
      <Tag
        ref={ ref }
        className={ textClasses }
        { ...props }
      >
        {children}
      </Tag>
    );
  }
);

Text.displayName = 'Text';
